// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#1abb97","riseColor":"#e93f4f","fallColor":"#12b887"};